const decodeErrorMessageFromResponse = (error) => {
  const data = error.response?.data;

  if (!data) return error.message;

  if (data instanceof ArrayBuffer) {
    return new TextDecoder().decode(data);
  }

  if (typeof data === 'string') return data;
  if (typeof data === 'object' && data.message) return data.message;

  return error.message;
};

export default decodeErrorMessageFromResponse;
